// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header[data-v-d8d01eca]{display:flex;align-items:center;justify-content:space-between;margin-bottom:20px;padding:0 20px;height:58px}.title[data-v-d8d01eca]{color:#0f2345;font-size:1.42857rem;font-weight:700}", ""]);
// Exports
module.exports = exports;
